// import { useState } from "react";
import { getTimeslotInfo } from "../../orchid-pro/Utils";
import { Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import { useAuthModals } from "contexts/auth-modals-context";

import getClasses from "utils/getClasses";
import styles from "./TimeslotButton.module.scss";

const formatStartTime = (start) => {
  // ex. 12:00 PM
  return new Date(start).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

const TimeslotButton = ({
  appointmentType,
  orchidPro,
  slot,
  isInModal,
  isClientPortal,
  setSelectedTimeslot,
}: any) => {
  const { user } = useUser();
  const { openAuthModals } = useAuthModals();
  const history = useHistory();
  const timeslot = getTimeslotInfo(slot, appointmentType);

  return isClientPortal ? (
    <Button
      variant="outline-primary"
      onClick={(e) => setSelectedTimeslot(timeslot)}
      className={getClasses("mx-auto my-2", styles["timeslot-btn"])}
    >
      {formatStartTime(slot.start)}
    </Button>
  ) : !isInModal ? (
    user?.signup_form_finished ? (
      <Button
        variant="outline-primary"
        as={Link}
        to={{
          pathname: `/professional-search/${orchidPro.custom_url}/checkout`,
          state: { pro: orchidPro, timeslot },
        }}
        // this only works on individual provider page for now
        onClick={() =>
          history.replace({
            search: `?session_type=${timeslot.appointmentType.label}`,
          })
        }
        className={`mx-auto my-2 ${styles["timeslot-btn"]}`}
      >
        {formatStartTime(slot.start)}
      </Button>
    ) : (
      <div
        className={`my-2 mx-auto ${styles["timeslot-btn"]}`}
        onClick={() => openAuthModals()}
      >
        {slot.start.getHours().toString().padStart(2, "0")}:
        {slot.start.getMinutes().toString().padStart(2, "0")}
      </div>
    )
  ) : (
    <Button
      variant="outline-primary"
      as={Link}
      to={{
        pathname: `/professional-search/${orchidPro.custom_url}/checkout`,
        state: { pro: orchidPro, timeslot },
      }}
      // this only works on individual provider page for now
      onClick={() =>
        history.replace({
          search: `?session_type=${timeslot.appointmentType.label}`,
        })
      }
      className={getClasses(
        "d-inline-block mr-2 mb-2",
        styles["timeslot-btn"],
        isInModal && styles["timeslot-btn--modal"],
      )}
    >
      {formatStartTime(slot.start)}
    </Button>
  );
};

export default TimeslotButton;
